import { render, staticRenderFns } from "./moveSelector.vue?vue&type=template&id=50024b8f&scoped=true&"
import script from "./moveSelector.vue?vue&type=script&lang=js&"
export * from "./moveSelector.vue?vue&type=script&lang=js&"
import style0 from "./moveSelector.vue?vue&type=style&index=0&id=50024b8f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50024b8f",
  null
  
)

export default component.exports